var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensionsSizeOperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.3435C1.45 12.3435 0.979167 12.1477 0.5875 11.756C0.195833 11.3643 0 10.8935 0 10.3435V2.34351C0 1.79351 0.195833 1.32267 0.5875 0.931006C0.979167 0.539339 1.45 0.343506 2 0.343506H18C18.55 0.343506 19.0208 0.539339 19.4125 0.931006C19.8042 1.32267 20 1.79351 20 2.34351V10.3435C20 10.8935 19.8042 11.3643 19.4125 11.756C19.0208 12.1477 18.55 12.3435 18 12.3435H2ZM2 10.3435H18V2.34351H15V6.34351H13V2.34351H11V6.34351H9V2.34351H7V6.34351H5V2.34351H2V10.3435Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensionsSizeOperation);
export default __webpack_public_path__ + "static/media/dimensions_size_operation.9eca5aa4a113c7a70491da6588af018f.svg";
export { ForwardRef as ReactComponent };